import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.632 16h.59a8.9 8.9 0 0 0 5.495-2.873c.326-.359.286-.735.274-.83a23.2 23.2 0 0 0-2.72-10.085 2 2 0 0 0-.287-.296A10.2 10.2 0 0 0 14.488.213a6 6 0 0 0-1.165-.207.8.8 0 0 0-.439.096.83.83 0 0 0-.324.318l-.202.341a.4.4 0 0 1-.15.157.4.4 0 0 1-.21.05h-.359a15 15 0 0 0-1.856 0h-.748a.37.37 0 0 1-.207-.041.4.4 0 0 1-.153-.151l-.1-.208a.87.87 0 0 0-.39-.462.83.83 0 0 0-.589-.085c-.764.099-1.514.298-2.23.592-.822.332-1.6.77-2.316 1.303q-.158.136-.273.311A22.6 22.6 0 0 0 0 12.401c-.001.232.075.456.216.637a7.7 7.7 0 0 0 2.33 1.866A9 9 0 0 0 6 15.94c.193.06.397.062.59.007a1.06 1.06 0 0 0 .504-.318l.748-1.036a.38.38 0 0 1 .345-.148q.716.115 1.439.148 1.064.078 2.13 0c.14-.012.28-.034.417-.056.198-.032.394-.063.59-.063a.34.34 0 0 1 .345.148l.791 1.067a.98.98 0 0 0 .734.31m.499-2.006a6.9 6.9 0 0 0 3.847-1.941 21.2 21.2 0 0 0-2.334-8.64 8.2 8.2 0 0 0-2.673-1.268l-.01-.002-.01-.003-.104-.028a2.39 2.39 0 0 1-1.877.856h-.391l-.06-.003a13 13 0 0 0-1.615 0l-.06.003h-.755a2.37 2.37 0 0 1-1.902-.844 7 7 0 0 0-1.061.339l-.01.004a8.4 8.4 0 0 0-1.697.927 20.6 20.6 0 0 0-2.403 8.654c.427.438.917.803 1.452 1.08l.012.007.011.006c.745.399 1.548.66 2.374.772l.362-.502.008-.01a2.38 2.38 0 0 1 2.216-.939l.028.004.027.005q.6.097 1.208.124l.028.001.029.002q.911.066 1.823.001c.06-.005.116-.014.232-.032l.131-.021c.155-.024.398-.06.675-.07a2.34 2.34 0 0 1 2.097.976z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.5 6a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m6 0a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }